import { jsx } from "react/jsx-runtime";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import { validateTidalLicense } from "../../base/index.js";
function DoDisturbOn(props) {
  return /* @__PURE__ */ jsx(
    DoDisturbOnIcon,
    {
      "data-testid": "DoDisturbOn",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DoDisturbOn",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
DoDisturbOn.tidalIconMeta = {
  categories: "cancel,informative",
  name: "DoDisturbOn"
};
validateTidalLicense();
export {
  DoDisturbOn
};
//# sourceMappingURL=DoDisturbOn.js.map
